import logo from './logo.svg';
import './App.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import React from 'react';
import SidebarWithHeader from './component/sidebar';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import Globle_app_context_function from './context/globle_context';

function App() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_zRVGFuBRX',
        userPoolClientId: '4icgbn4e7alp97ro74s9pc2e6r',
      },
    },
  });
  return (
    <div className="App">
      <BrowserRouter>
        <Globle_app_context_function>
          <SidebarWithHeader />
        </Globle_app_context_function>
      </BrowserRouter>
    </div>
  );
}

export default App;
